"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./index.scss");
var enhance = (0, recompose_1.compose)(react_router_dom_1.withRouter, recompose_1.pure);
exports.default = enhance(function (props) {
    var _a = React.useState(''), name = _a[0], setName = _a[1];
    var _b = React.useState(1), count = _b[0], setCount = _b[1];
    React.useEffect(function () {
        setName(props.initialName);
        setCount(props.initialCount);
    }, [props.initialName]);
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.open, className: 'diary-entries-modal' },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                props.closeModal();
            } }, (0, translation_1.getLocalization)("diaryEntryView/modal/".concat(props.localizationPrefix, "/edit"))),
        React.createElement("form", { onSubmit: function () {
                if (props.editInput && typeof props.currentIndex !== 'undefined') {
                    props.editInput(props.currentIndex, name, count);
                    props.closeModal();
                }
            } },
            React.createElement(sok_ui_1.Container, null,
                React.createElement("div", { className: 'modal-content' },
                    React.createElement("label", { htmlFor: 'modalname' }, (0, translation_1.getLocalization)("diaryEntryView/modal/".concat(props.localizationPrefix, "/name"))),
                    React.createElement(sok_ui_1.TextInput, { id: 'editmodalname', value: name, required: true, className: 'white', placeholder: (0, translation_1.getLocalization)("diaryEntryView/modal/".concat(props.localizationPrefix, "/placeholder")), onChange: function (e) {
                            setName(e.target.value.toString());
                        }, autoFocus: true, maxLength: 99 }),
                    React.createElement("label", { htmlFor: 'editmodalcount' }, (0, translation_1.getLocalization)('diaryEntryView/modal/count')),
                    React.createElement(sok_ui_1.TextInput, { type: 'text', inputMode: 'numeric', required: true, min: "0", id: 'editmodalcount', value: count >= 0 ? count : '', className: 'white', onChange: function (e) {
                            return setCount(parseInt(e.target.value, 10));
                        } }))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement("div", { className: "modal-buttons" },
                    React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntryView/modal/remove'), color: 'red', onClick: function () {
                            if (props.editInput &&
                                typeof props.currentIndex !== 'undefined') {
                                props.editInput(props.currentIndex, name, count, true);
                                props.closeModal();
                            }
                        } }),
                    React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntryView/modal/update'), type: "submit", color: 'base-green' }),
                    React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntryView/modal/cancel'), color: 'dark-gray', onClick: function () {
                            props.closeModal();
                        } }))))));
});
